import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  infoWrapper: {
    '&&': {
      display: 'inline-flex',
    },
  },
  infoList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
  },
  infoIcon: {
    '&&': {
      fill: theme.palette.primary.main,

      width: 20,
      height: 20,
    },
  },
}))
